import { render, staticRenderFns } from "./single-file-viewer-modal.vue?vue&type=template&id=4b81a6ed&scoped=true"
import script from "./single-file-viewer-modal.vue?vue&type=script&lang=js"
export * from "./single-file-viewer-modal.vue?vue&type=script&lang=js"
import style0 from "./single-file-viewer-modal.vue?vue&type=style&index=0&id=4b81a6ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81a6ed",
  null
  
)

export default component.exports